import React from "react";

import privacyDoc from "../../assets/pdf/PrivacyPolicy.pdf";
import termDoc from "../../assets/pdf/Terms&Conditions.pdf";
import "assets/css/safexpay-web.css";
import "./Registration.css";

class Welcome extends React.Component {
  render() {
    return (
      <>
        <table
          border="0"
          cellPadding="0"
          cellSpacing="0"
          style={{
            border: "1px solid #d2d2d2",
            margin: "0 auto",
            fontFamily: "Verdana",
            fontSize: "16px",
            lineHeight: "25px",
          }}
          width="750px"
        >
          <tr>
            <td>
              <img
                src={require("assets/img/email/img-01.png")}
                alt="safexpay-img"
              />
            </td>
          </tr>
          <tr>
            <td>
              <img
                src={require("assets/img/email/img-02.png")}
                alt="safexpay-img"
              />
            </td>
          </tr>
          <tr>
            <td bgcolor="#dddedf">
              <table
                border="0"
                cellPadding="0"
                cellSpacing="0"
                bgcolor="#ffffff"
                style={{ margin: "0 auto" }}
                width="658px"
              >
                <tr>
                  <td
                    style={{
                      paddingLeft: "50px",
                      paddingRight: "50px",
                      fontFamily: "Verdana",
                      fontSize: "16px",
                      lineHeight: "25px",
                    }}
                  >
                    <br />
                    Dear Customer,
                    <br />
                    <br />
                    Get started with Safexpay in 3 easy steps. Login with the
                    below User ID and Temporary Password,
                    <br />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div
                      style={{
                        background: "#d7d8d9",
                        height: "1px",
                        marginTop: "20px",
                        marginBottom: "20px",
                        marginLeft: "50px",
                        marginRight: "50px",
                      }}
                    >
                      &nbsp;
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      paddingLeft: "50px",
                      paddingRight: "50px",
                      fontFamily: "Verdana",
                      fontSize: "16px",
                      lineHeight: "25px",
                    }}
                  >
                    <span>Here is your Login information.</span>
                    <br />
                    <span>User ID : abc@gmail.com</span>
                    <br />
                    <span>Temporary Password : 12550</span>
                    <br />
                    <br />

                    <a href="/signuplogin" style={{ textDecoration: "none" }}>
                      <img
                        src={require("assets/img/email/img-03.png")}
                        alt="safexpay-img"
                      />
                    </a>
                    <br />
                    <br />

                    <p>
                      Click or copy the below link incase the button do not
                      appear. <br />
                      <a href="#" style={{ textDecoration: "underline" }}>
                        https://www.safexpay.com/signuplogin
                      </a>
                    </p>
                    {/* <p>
                      Please find attached below{" "}
                      <strong style={{ fontWeight: "600" }}>
                        List of Documents for Registration.
                      </strong>
                    </p> */}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div
                      style={{
                        background: "#d7d8d9",
                        height: "1px",
                        marginTop: "0px",
                        marginBottom: "10px",
                        marginLeft: "50px",
                        marginRight: "50px",
                      }}
                    >
                      &nbsp;
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      paddingLeft: "50px",
                      paddingRight: "50px",
                      fontFamily: "Verdana",
                      fontSize: "16px",
                      lineHeight: "25px",
                    }}
                  >
                    <div>
                      <p style={{ fontSize: "1rem" }}>
                        Please note, below are the policies that are mandatorily
                        required to be available on your website:
                      </p>
                      <ul style={{ marginLeft: "1rem" }}>
                        <li>About us</li>
                        <li>Privacy Policy</li>
                        <li>Terms & conditions</li>
                        <li>Refund & Cancellation policy</li>
                        <li>Shipping Policy (If Applicable)</li>
                        <li>Legal Entity with registered office address</li>
                        <li>Contact number & Email Id</li>
                        <li>Service Pricing</li>
                      </ul>
                    </div>
                    <p>
                      <label>
                        <a href={privacyDoc} download>
                          Sample Privacy Policy
                        </a>
                      </label>
                      <br />
                      <label>
                        <a href={termDoc} download>
                          {" "}
                          Sample Terms &amp; Conditions
                        </a>
                      </label>{" "}
                      <br />
                      <span style={{ fontWeight: "bold" }}>
                        Thanks for choosing Safexpay.
                      </span>
                      <br /> <br />- Team Safexpay.
                      <br />
                      <br />
                    </p>
                    <p style={{ textAlign: "center" }}>
                      <a
                        href="/support"
                        style={{ textDecoration: "underline" }}
                      >
                        Click here
                      </a>{" "}
                      to write to us for support.
                    </p>
                    <br />
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td bgcolor="#dddedf">
              <br />
              <p style={{ textAlign: "center" }}>
                <a
                  href="https://twitter.com/safexpay?s=21"
                  style={{ textDecoration: "none" }}
                  target="_blank"
                >
                  <img
                    src={require("assets/img/email/tw.png")}
                    alt="safexpay-img"
                  />
                </a>
                <a
                  href="https://www.facebook.com/safexpay/"
                  style={{ textDecoration: "none" }}
                  target="_blank"
                >
                  <img
                    src={require("assets/img/email/fb.png")}
                    alt="safexpay-img"
                  />
                </a>
                <a
                  href="https://instagram.com/thesafexpay?utm_medium=copy_link"
                  style={{ textDecoration: "none" }}
                  target="_blank"
                >
                  <img
                    src={require("assets/img/email/ins.png")}
                    alt="safexpay-img"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/safexpay"
                  style={{ textDecoration: "none" }}
                  target="_blank"
                >
                  <img
                    src={require("assets/img/email/link.png")}
                    alt="safexpay-img"
                  />
                </a>
              </p>

              {/* <p style={{ textAlign: "center", fontSize: "14px" }}>
                <strong> Questions?</strong>
                <br />
                Reply to this email or click on the given link.
                <a href="/">Support.</a>
              </p> */}
            </td>
          </tr>
        </table>
        <br />
        <br />
      </>
    );
  }
}

export default Welcome;
